export default {"src":"/_next/static/media/SNA.38a41b94.svg","height":18,"width":18};